<template>
  <landing-page
    label="factSheet.prostateCancerTitle"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'prostateCancerLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div class="font-bold text-description">{{ t("factSheet.whatIsProstateCancer") }}</div>
      <div v-html="t('factSheet.whatIsProstateCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.whatCausesIt") }}</div>
      <div v-html="t('factSheet.whatCausesItDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <li v-html="t('factSheet.ageDesc')" />
        <li v-html="t('factSheet.familyHistoryOfProstateCancer')" />
      </ul>
    </div>

    <div v-html="t('factSheet.resultsFromStudy')" class="space-y-5" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.commonSymptoms") }}</div>
      <div v-html="t('factSheet.earlyProstate')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <li v-html="t('factSheet.diffUrinating')" />
        <li v-html="t('factSheet.slowUrinating')" />
        <li v-html="t('factSheet.bloodUrine')" />
        <li v-html="t('factSheet.painLowerBack')" />
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.howToPrevent") }}</div>
      <ul class="bullet-big">
        <li v-html="t('factSheet.adoptHealthLifestyle')" />
        <li v-html="t('factSheet.familyHistoryCancer')" />
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.suspiciousSymptoms") }}</div>
      <div v-html="t('factSheet.suspiciousSymptomsDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.screeningProstateCancer") }}</div>
      <div v-html="t('factSheet.screeningProstateCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.whoHigherRisk") }}</div>
      <ol>
        <template v-for="(item, index) in factSheetStore.prostateCancerFactList" :key="'prostateCancerFact' + index">
          <li>{{ t(item.label) }}</li>
          <div class="text-description" v-if="item.desc">{{ t(item.desc) }}</div>
          <ul class="bullet-big mt-12 mb-12" v-if="item.list">
            <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
              <li v-html="t(listItem)" />
            </template>
          </ul>
        </template>
      </ol>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.furtherTest") }}</div>
      <div v-html="t('factSheet.furtherTestDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.treatment") }}</div>
      <div v-html="t('factSheet.treatmentDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big space-y-12">
        <li v-html="t('factSheet.watchfulWaiting')" />
        <li v-html="t('factSheet.surgery')" />
        <li v-html="t('factSheet.hormoneTherapyDesc1')" />
        <li v-html="t('factSheet.radioTherapy')" />
        <li v-html="t('factSheet.watchfulWaitingDesc')" />
      </ul>
    </div>

    <div v-html="t('factSheet.osteoporosisRef')" class="mt-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.prostateCancer") }}</div>
      </div>

      <div>
        <div v-html="t('factSheetChinese.whatIsProstateCancerDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.whatCausesIt") }}</div>
        <div v-html="t('factSheetChinese.whatCausesItDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <li v-html="t('factSheetChinese.ageDesc')" />
          <li v-html="t('factSheetChinese.familyHistoryOfProstateCancer')" />
        </ul>
      </div>

      <div v-html="t('factSheetChinese.resultsFromStudy')" class="space-y-5" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.commonSymptoms") }}</div>
        <div v-html="t('factSheetChinese.earlyProstate')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <li v-html="t('factSheetChinese.diffUrinating')" />
          <li v-html="t('factSheetChinese.slowUrinating')" />
          <li v-html="t('factSheetChinese.bloodUrine')" />
          <li v-html="t('factSheetChinese.painLowerBack')" />
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.howToPrevent") }}</div>
        <ul class="bullet-big">
          <li v-html="t('factSheetChinese.adoptHealthLifestyle')" />
          <li v-html="t('factSheetChinese.familyHistoryCancer')" />
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.suspiciousSymptoms") }}</div>
        <div v-html="t('factSheetChinese.suspiciousSymptomsDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.screeningProstateCancer") }}</div>
        <div v-html="t('factSheetChinese.screeningProstateCancerDesc')" class="space-y-5" />
      </div>

      <div>
        <ol>
          <template v-for="(item, index) in factSheetStore.prostateCancerFactList" :key="'prostateCancerFact' + index">
            <li>{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</li>
            <div class="text-description" v-if="item.desc">{{ t(item.desc.replace("factSheet", "factSheetChinese")) }}</div>
            <ul class="bullet-big mt-12 mb-12" v-if="item.list">
              <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
                <li v-html="t(listItem.replace('factSheet', 'factSheetChinese'))" />
              </template>
            </ul>
          </template>
        </ol>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.treatment") }}</div>
        <div v-html="t('factSheetChinese.treatmentDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big space-y-12">
          <li v-html="t('factSheetChinese.watchfulWaiting')" />
          <li v-html="t('factSheetChinese.surgery')" />
          <li v-html="t('factSheetChinese.hormoneTherapyDesc1')" />
          <li v-html="t('factSheetChinese.radioTherapy')" />
          <li v-html="t('factSheetChinese.watchfulWaitingDesc')" />
        </ul>
      </div>

      <div v-html="t('factSheetChinese.osteoporosisRef')" class="mt-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>